import Vue from 'vue'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
    config: { id: 'G-BP5BKE7CC7' }
})
